export default {
  RESELLERS_LIST: "Resellers List",
  ADD_RESELLER: "Add Reseller",
  RESELLER_ADDED: "Reseller Added",
  EDIT_RESELLER: "Edit Reseller",
  RESELLER_ADDED: "Reseller Added",
  DELETE_THIS_RESELLER: "Delete this Reseller?",
  RESELLER_DELETED: "Reseller Deleted",
};
